import React, { useEffect, useState } from 'react';
import {
  BackTop,
  Breadcrumb,
  Button,
  ConfigProvider,
  Pagination,
  Popconfirm,
  Space,
  Table,
  Tooltip,
} from 'antd';
import { HomeOutlined, EditOutlined, DeleteFilled } from '@ant-design/icons';
import plPL from 'antd/lib/locale/pl_PL';
import { Link } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import {
  deleteUserById,
  getUsers,
} from 'modules/userModule/request/userRequest';
import { UserDto } from 'modules/userModule/userDtos';
import TableDateRow from 'modules/layoutModule/components/TableDateRow/TableDateRow';
import TableDataRowTypes from 'modules/layoutModule/enums/TableDataRowTypes';

const Users = () => {
  const [loading, toggleLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<UserDto[]>([]);

  const downloadUsers = () =>
    getUsers().then((response) => {
      if (response) {
        setTableData(response);
        toggleLoading(false);
      } else {
        toggleLoading(false);
      }
    });

  const confirmDelete = (userId: string) => {
    deleteUserById(userId).then(async (response) => {
      if (response) {
        await downloadUsers();
      }
    });

    return null;
  };

  useEffect(() => {
    if (tableData.length === 0) {
      downloadUsers();
    }
  }, [tableData]);

  const columns = [
    {
      title: 'Nazwa użytkownika',
      dataIndex: 'name',
      key: 'name',
      width: 300,
    },
    {
      title: 'Login',
      dataIndex: 'username',
      width: 300,
    },
    {
      title: 'Moduły',
      dataIndex: 'modules',
      render: (text: string, record: any) => (
        <TableDateRow record={record} field={TableDataRowTypes.MODULES} />
      ),
    },
    {
      title: 'Ostatnie logowanie',
      dataIndex: 'dataLogin',
      width: 100,
      render: (text: string, record: any) => (
        <TableDateRow record={record} field={TableDataRowTypes.DATE_LOGIN} />
      ),
    },
    {
      title: 'Akcje',
      dataIndex: 'operation',
      key: 'operation',
      width: 100,
      render: (text: string, item: { userId: string }) => (
        <Space
          size="middle"
          style={{ display: 'Flex', flexDirection: 'column' }}
        >
          <Tooltip title="Edytuj wpis">
            <Link to={`/users/${item.userId}`}>
              <Button type="primary" shape="circle" icon={<EditOutlined />} />
            </Link>
          </Tooltip>
          <Tooltip title="Usuń wpis">
            <Popconfirm
              title="Czy na pewno chcesz usunąc ten wpis?"
              placement="left"
              onConfirm={() => confirmDelete(item.userId)}
              okText="Tak"
              cancelText="Nie"
            >
              <Button type="link">
                <DeleteFilled />
              </Button>
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Ustawienia Administratorów</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/users">Administratorzy</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <Table
          columns={columns}
          dataSource={tableData}
          loading={loading}
          rowKey={(record) => record.userId}
        >
          <Pagination />
        </Table>
        <BackTop />
      </ConfigProvider>
    </>
  );
};

export default Users;
